import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {WalkOfShame} from "../WalkOfShame";
import {WalkOfShameSound} from "../sound/WalkOfShameSound";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {WalkOfShameReelController} from "../reels/WalkOfShameReelController";
import {WalkOfShameGameMode} from "../server/WalkOfShameGameMode";
import {WalkOfShameGameConfig} from "../WalkOfShameGameConfig";

export class WalkOfShameNormalBetPresentation implements FlowStatePresentation {

    private _normalStartDelay: number = 0.06;
    private _fastStartDelay: number = 0.01;

    constructor() {
    }

    public start(flowStateController: FlowStateController): void {
        WalkOfShameGameConfig.WALK_COMPLETED = true;
        WalkOfShameGameConfig.SYMBOLS_COUNT_IN_REELS = [3, 4, 4, 4, 4];
        WalkOfShame.possibleWays.updatePossibleWays(false);

        WalkOfShame.winWays.hideToggleWinAmountNWays();

        WalkOfShame.symbolCount.hideAll();

        WalkOfShameSound.soundPlayer.playTrack({name: WalkOfShameSound.REELS_SPINNING});

        const promises: Promise<any>[] = [];
        WalkOfShame.reels.forEach((reel: WalkOfShameReelController, reelId: number) => {
            promises.push(reel.startSpin(true, (WalkOfShame.apiPlugin.settings.get(APISetting.FAST_SPIN) ? this._fastStartDelay : this._normalStartDelay) * reelId));
        });

        if (WalkOfShame.model.data && (WalkOfShame.model.data.nextMode === WalkOfShameGameMode.NORMAL || WalkOfShame.model.data.nextMode === WalkOfShameGameMode.FREESPIN || WalkOfShame.model.data.nextMode === WalkOfShameGameMode.SUPER_FREESPIN)) {
            WalkOfShame.mToWild.turnOffAllCharacters();

            if (WalkOfShame.model.data.nextMode !== WalkOfShameGameMode.SUPER_FREESPIN) {
                WalkOfShame.stickyS2.toggleS2(false, -1);
            }
        } else {
            promises.push(Promise.resolve(WalkOfShame.mToWild.doWalkAnimation()));
        }

        Promise.all(promises).then(() => flowStateController.finish());
    }
}